<template>
	<div class="select">
		<select v-model="selected">
			<option :value="null" disabled="disabled" hidden="hidden">
				{{ placeholder }}
			</option>
			<option v-for="(option, index) in options" :key="index" :option="option">
				{{ option }}
			</option>
		</select>
	</div>
</template>

<script>
export default {
	name: "FieldSelect",
	props: {
		options: {
			type: Array,
			required: true
		},
		placeholder: {
			type: String,
			default: () => "Please select"
		},
		preSelect: {
			type: String,
			default: () => null
		}
	},
	data() {
		return {
			selected: null
		};
	},
	watch: {
		selected(data) {
			this.$emit("change", data);
		},
		preSelect(value) {
			this.selected = value;
		}
	},
	created() {
		if (this.preSelect) {
			this.selected = this.preSelect;
		}
	}
};
</script>

<style scoped>
.field.only-two >>> .control {
	width: 50%;
}
</style>
